import React, { useState } from "react";
// ui
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import AccountCircle from "@mui/icons-material/AccountCircle";
import Button from "@mui/material/Button";
import DeleteIcon from "@mui/icons-material/Delete";
// style
import { createStyles, makeStyles, styled } from "@material-ui/styles";
import OutlinedInput from "@mui/material/OutlinedInput";
import PropTypes from "prop-types";
import EmailIcon from "@mui/icons-material/Email";
import classNames from "classnames";
// config

// useStyle
const useStyles = makeStyles((theme) =>
  createStyles({
    root: {},
  })
);

// basic style
const StyledButton = styled(Button)(({ theme }) => ({
  width: "240px",
  height: "32px",
  padding: "9px 12px",
  borderRadius: "4px",
  // position: "relative",
  "&.MuiButton-root": {},
  "&.MuiButton-contained": {},
  "& .MuiButton-startIcon": {
    // position: "absolute",
    // left: "15px",
  },
}));

// fullWidth or custom width
const StyledButtonFlexible = styled(Button)(({ theme }) => ({
  height: "32px",
  padding: "9px 12px",
  borderRadius: "4px",
  // position: "relative",
  "&.MuiButton-root": {},
  "&.MuiButton-contained": {},
  "& .MuiButton-startIcon": {
    // position: "absolute",
    // left: "15px",
  },
}));

//
const TextButton = ({ text, fullWidth, customWidth, ...rest }) => {
  // style
  const classes = useStyles();
  // props
  const { className } = rest;
  // local state

  //
  if (fullWidth || customWidth) {
    return (
      <StyledButtonFlexible
        variant="text"
        fullWidth={fullWidth === true}
        {...rest}
        className={classNames(className)}
      >
        {text}
      </StyledButtonFlexible>
    );
  }
  return (
    <StyledButton variant="text" {...rest} className={classNames(className)}>
      {text}
    </StyledButton>
  );
};

TextButton.propTypes = {
  text: PropTypes.string,
  fullWidth: PropTypes.bool,
  customWidth: PropTypes.bool,
};

TextButton.defaultProps = {
  text: "click me",
  fullWidth: false,
  customWidth: false,
};

export default TextButton;
